import React, { useState, useEffect } from 'react';
function timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
const LaneRateResponse = (props) => {
    const [loaded, setLoaded] = useState(false);
    const [redirect, setRedirect] = useState(null);
    useEffect(async () => {
        try {
            if (window.location.pathname.includes('confirm')) {
                // append token and confirmation to the query string
                setRedirect(`/${window.location.search}&confirmLaneRates=true`);
            }
            else {
                setRedirect(`/${window.location.search}&confirmLaneRates=false`);
            }
            await timeout(2000);
            setLoaded(true);
        }
        catch (e) {
            setRedirect('/');
            setLoaded(true);
            console.log('error appending values to query string', props.match.params.id, 'err:', e.message);
        }
    }, []);
    if (!loaded) {
        return (React.createElement("div", { className: "flex justify-center p-16 font-bold" }, "Loading Lane Rates Data..."));
    }
    window.location.href = redirect;
};
export default LaneRateResponse;
